import { computed, toValue, type MaybeRefOrGetter } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import { ENTITY_LIST_QUERY_OPTIONS } from '../constants';

import { queryKeys } from '../queryKeys';

import { getUnassignedProperties } from '@/modules/Team/api/teamApi';
import { useTeamDependencies } from '@/modules/Team/composables/useTeamDependencies';

export function useUnassignedPropertiesQuery(
  teamMemberId: MaybeRefOrGetter<string | undefined>,
) {
  const { apiClient, accountId } = useTeamDependencies();

  return useQuery({
    queryKey: computed(() => {
      const id = toValue(teamMemberId);
      return id
        ? queryKeys.properties.unassigned(accountId.value, id)
        : queryKeys.properties.all;
    }),
    queryFn: () => getUnassignedProperties({
      accountId: accountId.value,
      teamMemberId: toValue(teamMemberId)!,
      deps: { apiClient },
    }),
    enabled: computed(() => Boolean(accountId.value && toValue(teamMemberId))),
    ...ENTITY_LIST_QUERY_OPTIONS,
  });
}
